<template>
  <div class="host">
    <h2>Список клиник</h2>
    <!--input
      v-model="searchControl"
      class="form-control"
      type="search"
      placeholder="Поиск..."
    /-->
    <searchInput v-model="searchControl" />
    <div  v-if="!loading">
    <CustomList v-for="obj in items" :key="obj.id" :item="obj" :loading="loading" :avatar="obj.logo" :timeout="200">
          <template slot="info">
              <div class="title">{{ obj.title }}</div>
          <div v-if="obj.website" class="subtitle">{{ obj.website }}</div>
          </template>
          <template slot="rightSideInfo">
          <b-button
            @click="chooseClinic(obj)"
            class="vm-button"
          >
            Выбрать
          </b-button>
        </template>
        </CustomList>
    </div>
    <!--div v-if="!loading" class="items" @resize="widthItem()">
      <div v-for="item in items" :key="item.id" class="item" style="height:140px; background:whitesmoke">
        <div v-bind:style="widthItem()" style="position:absolute; height:35px; background:white"></div>
        <div class="item-logo" style="margin-left:30px; z-index:2; background:white; border:4px whitesmoke solid">
          <img v-if="item.logo" :src="item.logo" alt="logo" />
          <svg
            v-else
            class="bi bi-camera"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M9 5C7.343 5 5 6.343 5 8a4 4 0 0 1 4-4v1z" />
            <path
              fill-rule="evenodd"
              d="M14.333 3h-2.015A5.97 5.97 0 0 0 9 2a5.972 5.972 0 0 0-3.318 1H1.667C.747 3 0 3.746 0 4.667v6.666C0 12.253.746 13 1.667 13h4.015c.95.632 2.091 1 3.318 1a5.973 5.973 0 0 0 3.318-1h2.015c.92 0 1.667-.746 1.667-1.667V4.667C16 3.747 15.254 3 14.333 3zM1.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM9 13A5 5 0 1 0 9 3a5 5 0 0 0 0 10z"
            />
            <path d="M2 3a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1z" />
          </svg>
        </div>
        <div class="vm-item-info">
          <div class="title">{{ item.title }}</div>
          <div v-if="item.website" class="subtitle">{{ item.website }}</div>
        </div>
        <div class="vm-item-action">
          <router-link
            :to="{
              name: 'clinic.public',
              params: { clinicName: item.slug ? item.slug : item.id }
            }"
            class="vm-button"
          >
            Выбрать
          </router-link>
        </div>
      </div>
    </div-->
    <div v-else class="items loader">
      <div v-for="item in loadingBlocks" :key="item" class="item">
        <div class="item-logo loading-block"></div>
        <div class="vm-item-info">
          <div class="title loading-block"></div>
          <div class="subtitle loading-block"></div>
        </div>
        <div class="vm-item-action">
          <div class="vm-face-link loading-block"></div>
        </div>
      </div>
    </div>
    <b-pagination
      v-if="items.length"
      v-model="currentPage"
      :total-rows="length"
      :per-page="pageSize"
      size="sm"
      align="right"
    ></b-pagination>
  </div>
</template>

<script>
import { adminApi } from '@app/services';
import { debounce } from 'lodash';
import searchInput from '@app/components/uikit/searchInput';
import CustomList from '@app/components/uikit/CustomList';


export default {
  components: {searchInput, CustomList},
  data: () => ({
    loading: false,
    searchControl: null,
    items: [],
    currentPage: 1,
    length: 0,
    pageSize: 20,
    loadingBlocks: [],
    itemWidth: 0
  }),
  watch: {
    currentPage: async function(page) {
      const offset = page; // this.pageSize * (page - 1); console.log(offset, page, this.pageSize);
      await this.load(offset, this.pageSize);
    },
    searchControl: debounce(async function(value) {
      const offset = 1; //this.currentPage; // this.pageSize * (this.currentPage - 1);
      await this.load(offset, this.pageSize, value);
    }, 500)
  },
  created() {
    this.loadingBlocks = Array.from(new Array(this.pageSize)).map((d, i) => i);
    this.reflash();
  },
  methods: {
    chooseClinic(obj) {
      localStorage.setItem('lastClinic', JSON.stringify({id: obj.id, title: obj.title, slug: obj.slug}));
      this.$router.push({ name: 'clinic.public', params: { clinicName: obj.slug ? obj.slug : obj.id }});
     /* :to="{
              name: 'clinic.public',
              params: { clinicName: obj.slug ? obj.slug : obj.id }
            }" */
    },
    async load(offset, limit, search) {
      this.loading = true;
      try {
        const { items, total } = await adminApi.getAll(limit, offset, search);
        this.length = total;
        this.items = items;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
    async reflash() {
      const offset = this.pageSize * (this.currentPage - 1);
      await this.load(offset, this.pageSize);
    },
   
  }
};
</script>

<style lang="scss" scoped>
.host {
  padding: 2rem;
  max-width: 900px;
  min-width: 600px;
  width: 56%;
}
h2 {
  margin-bottom: 2rem;
}
.items {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.item {
  display: flex;
  margin-top: 1rem;
 /* border: 1px solid #dfdfdf;
  border-radius: 0.25rem; */
  background-color: white;
 /* box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.02); */
  transition: background-color 200ms ease;
  overflow: hidden;
}
.item:first-child {
  margin-top: 0;
}
.item-logo {
  height: 100px;
  overflow: hidden;
  flex: 0 0 100px;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.05);
}
.item-logo img {
  max-width: 100%;
  max-height: 100%;
}
.item-logo svg {
  width: 50px;
  height: 50px;
}
.vm-item-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.vm-item-info .title {
  font-size: 1.5rem;
  color: #262626;
  margin-bottom: 6px;
  line-height: 1;
}
.vm-item-info .subtitle {
  color: #606368;
  line-height: 1;
}
.vm-item-action {
  margin-left: auto;
  display: flex;
  align-items: flex-end;
  padding: 1rem;
}
.vm-button {
  font-weight: 300;
  background: linear-gradient(to right, #8C30DA, #5C48D4);
  border: 1px solid #dbdbdb;
  border-radius: 25px;
  color: white;
  padding: 0.5rem 3rem;
  transition: all 200ms;
  outline: none;
  text-decoration: none;
}
.vm-button:hover {
  border: 1px solid #6cbdee;
  background-color: #6cbdee;
  color: #000;
}
.items.loader .vm-item-info {
  width: 100%;
}
.items.loader .vm-item-info .title {
  height: 24px;
  width: 100%;
  max-width: 300px;
  background-color: rgba(0, 0, 0, 0.05);
}
.items.loader .vm-item-info .subtitle {
  height: 16px;
  width: 100%;
  max-width: 200px;
  background-color: rgba(0, 0, 0, 0.05);
}
.items.loader .vm-face-link {
  height: 42px;
  width: 98.11px;
  background-color: rgba(0, 0, 0, 0.05);
}
::v-deep .vm-item-action {
  justify-content: center;
}

::v-deep .item-logo {
  transform: translate(0px, -15px);
  transition: all 1000ms ease;
}
::v-deep .item {
  height: 110px;
  transition: all 300ms ease;
  width: 100%; 
}
::v-deep .item:hover {
  background: linear-gradient(to right, #e5cef8, transparent);
  transform: translate(5px, 5px);
  transition: all 300ms ease;
  .item-logo {
    transform: translate(0px, 5px);
    transition: all 300ms ease;
  }
}
</style>
